module.exports = __webpack_public_path__ + "img/cust_create_un.1d050152.png";